<div
  class="exit-app-container horizontal-center back-btn"
  (click)="disabled($event)"
  (keydown)="handleKeydown($event)"
  (mousedown)="disabled($event)"
  (mouseup)="disabled($event)"
>
  <div
    id="exit-app-modal"
    class="exit-app-modal horizontal-focusable-container generic-dialog"
  >
    <h2 [style]="'fontSize.36' | translate">{{ 'exit_title' | translate }}</h2>
    <p [style]="'fontSize.28' | translate">{{ 'exit_desc' | translate }}</p>
    <div class="actions horizontal-as">
      <app-icon-button
        class="cancel-button"
        [label]="'global.no' | translate"
        (clicked)="cancelAction()"
      ></app-icon-button>
      <app-icon-button
        [label]="'global.yes' | translate"
        (clicked)="exitAction()"
      ></app-icon-button>
    </div>
  </div>
</div>
